export const Switch = {
    MuiSwitch: {
        defaultProps: {
            size: "small"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    "&.MuiSwitch-sizeSmall": {
                        width: 38,
                        height: 23,
                        padding: 0,
                        "& .MuiSwitch-thumb": {
                            boxSizing: "border-box",
                            marginTop: 1,
                            width: 17.25,
                            height: 17.25,
                            color: theme.palette.action.disabled,
                            marginLeft: 1
                        },
                        "& .MuiSwitch-track": {
                            borderRadius: 23 / 2,
                            border: "1px solid #B9CBEE",
                            backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
                            opacity: 1,
                            transition: theme.transitions.create([
                                "background-color"
                            ], {
                                duration: 500
                            })
                        }
                    },
                    "&.MuiSwitch-sizeMedium": {
                        width: 42,
                        height: 26,
                        padding: 0,
                        "& .MuiSwitch-thumb": {
                            boxSizing: "border-box",
                            width: 22,
                            height: 22,
                            color: theme.palette.action.disabled
                        },
                        "& .MuiSwitch-track": {
                            borderRadius: 26 / 2,
                            border: "1px solid grey",
                            backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
                            opacity: 1,
                            transition: theme.transitions.create([
                                "background-color"
                            ], {
                                duration: 500
                            })
                        }
                    },
                    "& .MuiSwitch-switchBase": {
                        padding: 0,
                        margin: 2,
                        transitionDuration: "300ms",
                        "&.Mui-checked": {
                            transform: "translateX(16px)",
                            color: "#fff",
                            "& + .MuiSwitch-track": {
                                backgroundColor: theme.palette.primary.main,
                                opacity: 1,
                                border: 0
                            },
                            "&.Mui-disabled + .MuiSwitch-track": {
                                opacity: 0.5
                            }
                        },
                        "&.Mui-disabled .MuiSwitch-thumb": {
                            color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]
                        },
                        "&.Mui-checked .MuiSwitch-thumb": {
                            color: "#fff",
                            marginLeft: 0
                        },
                        "&.Mui-disabled + .MuiSwitch-track": {
                            opacity: theme.palette.mode === "light" ? 0.7 : 0.3
                        }
                    }
                })
        }
    }
};

//# sourceMappingURL=Switch.js.map